import { render, staticRenderFns } from "./read-text-and-router.vue?vue&type=template&id=71a474b4"
import script from "./read-text-and-router.vue?vue&type=script&setup=true&lang=js"
export * from "./read-text-and-router.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports